import { render, staticRenderFns } from "./detail_modal.vue?vue&type=template&id=6b183de6&scoped=true&"
import script from "./detail_modal.vue?vue&type=script&lang=js&"
export * from "./detail_modal.vue?vue&type=script&lang=js&"
import style0 from "./detail_modal.vue?vue&type=style&index=0&id=6b183de6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b183de6",
  null
  
)

export default component.exports